module.exports = __webpack_public_path__ + "static/img/not_paid.b84b02da.svg";